import '../assets/styles/AboutUs.scss';

interface Props {
  heading: string;
  paragraphs: string[]
}

const About = ({ heading, paragraphs }: Props) => {
  const sectionId = heading === 'About iOS' ? 'about-ios' : 'aboutUs';
  return (
    <div id={sectionId} className='aboutUs-container'>
      <h1>{heading}</h1>
      {
        paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)
      }
    </div>
  )
}

export default About